import React from 'react';
import {
  Box,
  Container,
  Flex,
  HStack,
  Link,
  Text,
  VStack,
  useColorModeValue,
  useBreakpointValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const bg = useColorModeValue('gray.50', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const linkColor = useColorModeValue('purple.600', 'purple.400');
  const hoverColor = useColorModeValue('purple.700', 'purple.300');
  const isMobile = useBreakpointValue({ base: true, md: false });

  const currentYear = new Date().getFullYear();

  return (
    <Box
      as="footer"
      bg={bg}
      borderTop="1px"
      borderColor={borderColor}
      mt="auto"
      py={6}
      w="100%"
    >
      <Container maxW="1200px" px={4}>
        <VStack spacing={4} align="stretch">
          {isMobile ? (
            <VStack spacing={3} align="stretch">
              <HStack spacing={4} justify="center" flexWrap="wrap">
                <Link
                  onClick={() => navigate('/privacy')}
                  color={linkColor}
                  fontSize="sm"
                  _hover={{ color: hoverColor, textDecoration: 'underline' }}
                  cursor="pointer"
                >
                  Privacy Policy
                </Link>
                <Link
                  onClick={() => navigate('/terms')}
                  color={linkColor}
                  fontSize="sm"
                  _hover={{ color: hoverColor, textDecoration: 'underline' }}
                  cursor="pointer"
                >
                  Terms of Service
                </Link>
              </HStack>
              <Text fontSize="xs" color={textColor} textAlign="center">
                © {currentYear} Vindie Stream. All rights reserved.
              </Text>
            </VStack>
          ) : (
            <Flex justify="space-between" align="center" flexWrap="wrap" gap={4}>
              <Text fontSize="sm" color={textColor}>
                © {currentYear} Vindie Stream. All rights reserved.
              </Text>
              <HStack spacing={6}>
                <Link
                  onClick={() => navigate('/privacy')}
                  color={linkColor}
                  fontSize="sm"
                  _hover={{ color: hoverColor, textDecoration: 'underline' }}
                  cursor="pointer"
                >
                  Privacy Policy
                </Link>
                <Link
                  onClick={() => navigate('/terms')}
                  color={linkColor}
                  fontSize="sm"
                  _hover={{ color: hoverColor, textDecoration: 'underline' }}
                  cursor="pointer"
                >
                  Terms of Service
                </Link>
              </HStack>
            </Flex>
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;

